import type { FeatureConfig } from '@platform/client/features/feature-config';

export default {
  routes: [
    {
      // This path is provided so customers can download bulk log exports that were generated by S2.
      path: 'bulk-log-download/:queryId/:outputId/:fileId',
      lazy: () => import('./pages/download/download.page'),
    },
  ],

  // navigation is required, this feature has none because the url to the page is generated by an external tool
  navigation: () => ({}),
} satisfies FeatureConfig;
